module.exports = __webpack_public_path__ + "19b56cfcb97fbcc245242fb28232939e.ttf";


//////////////////
// WEBPACK FOOTER
// ./node_modules/open-sans-fontface/fonts/ExtraBold/OpenSans-ExtraBold.ttf?v=1.1.0
// module id = 1015
// module chunks = 0